import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Reveal from './Reveal';
import AnimatedTitle from './AnimatedTitle';
import { eyebrowSx } from '../style/homeStyles';

// Bloque "eyebrow + título" que abre cada sección de la home.
const SectionHeading = ({
  eyebrow, title, highlight, titleFontSize, mb, component,
}) => (
  <Reveal sx={{ marginBottom: `${mb}px` }}>
    {/* El flex aísla al chip del textAlign y del line-height de la sección. */}
    <Box sx={{ display: 'flex', marginBottom: '12px' }}>
      <Typography component="span" sx={eyebrowSx}>
        {eyebrow}
      </Typography>
    </Box>
    <AnimatedTitle
      component={component}
      text={title}
      highlight={highlight}
      fontSize={titleFontSize}
    />
  </Reveal>
);

SectionHeading.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  highlight: PropTypes.string,
  titleFontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  mb: PropTypes.number,
  component: PropTypes.string,
};

SectionHeading.defaultProps = {
  highlight: '',
  titleFontSize: 28,
  mb: 22,
  component: 'h2',
};

export default SectionHeading;
